import { PromisePool } from 'es6-promise-pool';

import { APIsendWelcomeEmail } from '../api/User';

import { addFlashMessage } from './FlashMessages';
import { getIntl } from './IntlInstance';

export const defaultAvatarUrl = '/images/user-avatar.jpg';

const getWelcomeEmailsPromisePool = (userUuids) => {
  let counterEmails = 0;
  const promiseProducerEmails = () => {
    if (counterEmails < userUuids.length) {
      const userUuid = userUuids[counterEmails];
      counterEmails += 1;
      return APIsendWelcomeEmail(userUuid);
    }
    return null;
  };

  return new PromisePool(promiseProducerEmails, 2);
};

export const sendWelcomeEmails = userUuids => (
  getWelcomeEmailsPromisePool(userUuids).start().then(() => {
    const intl = getIntl();
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: `Activation {count, plural, one {email has} other {emails have}} been sent`,
      }, { count: userUuids.length }),
    });
  })
);

export const getBuiltInRoles = (allowedRoles = []) => {
  const intl = getIntl();
  const builtInRoles = [];

  if (allowedRoles.length === 0 || allowedRoles.includes('user')) {
    builtInRoles.push({
      value: 'user',
      label: intl.formatMessage({ defaultMessage: 'User' }),
      description: intl.formatMessage({ defaultMessage: 'Can only edit files and Collections that belong to them' }),
    });
  }
  if (allowedRoles.length === 0 || allowedRoles.includes('manager')) {
    builtInRoles.push({
      value: 'manager',
      label: intl.formatMessage({ defaultMessage: 'Manager' }),
      description: intl.formatMessage({
        defaultMessage: `Can only edit files and Collections that belong to
        them + full access to workspace settings`,
      }),
    });
  }
  if (allowedRoles.length === 0 || allowedRoles.includes('admin')) {
    builtInRoles.push({
      value: 'admin',
      label: intl.formatMessage({ defaultMessage: 'Admin' }),
      description: intl.formatMessage({ defaultMessage: 'Full access to workspace settings and all user files' }),
    });
  }

  return builtInRoles;
};
